import { useState, useEffect } from 'react';
import { DownloadSimple, X } from '@phosphor-icons/react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('gz_install_dismissed') === 'true');

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    setDismissed(true);
    localStorage.setItem('gz_install_dismissed', 'true');
  };

  if (!deferredPrompt || dismissed) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-6 sm:w-80 z-40 bg-[#0F172A] border border-[#2563EB]/40 rounded-xl p-4 shadow-2xl shadow-black/40 flex items-center gap-3" data-testid="install-prompt">
      <img src="/icon-192.png" alt="Gazelle" className="h-10 w-10 rounded-lg flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#F8FAFC]">Installer l'application</p>
        <p className="text-xs text-[#94A3B8]">Ajoutez TEAM GAZELLE à votre écran d'accueil</p>
      </div>
      <button onClick={install} className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-xs font-medium px-3 py-2 rounded-md flex items-center gap-1.5 flex-shrink-0 transition-colors" data-testid="install-app-button">
        <DownloadSimple size={14} weight="bold" /> Installer
      </button>
      <button onClick={dismiss} className="text-[#64748B] hover:text-white flex-shrink-0" data-testid="install-dismiss-button">
        <X size={16} />
      </button>
    </div>
  );
};

export default InstallPrompt;
